import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "./components/Header";
import { Toaster } from "./components/ui/sonner";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Updates } from "./pages/Updates";
import { Activity } from "./pages/Activity";
import { Profile } from "./pages/Profile";
import { Subscribe } from "./pages/Subscribe";
import { Library } from "./pages/Library";
import { VipAgreement } from "./pages/VipAgreement";
import { DStudio } from "./pages/DStudio";
import { Halftone } from "./pages/Halftone";
import { Ascii } from "./pages/Ascii";
import { Raster } from "./pages/Raster";
import { Admin } from "./pages/Admin";
import { AuthProvider } from "./contexts/AuthContext";
import { LoginDialog } from "./components/LoginDialog";
import { RegisterDialog } from "./components/RegisterDialog";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-white min-w-[1440px]">
          <Header />
          <Toaster />
          <LoginDialog />
          <RegisterDialog />
          <AdminShortcut />
          <ToolQueryRedirect />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/updates" element={<Updates />} />
            <Route path="/settings" element={<Profile />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/dstudio" element={<DStudio />} />
            <Route path="/halftone" element={<Halftone />} />
            <Route path="/ascii" element={<Ascii />} />
            <Route path="/raster" element={<Raster />} />
            <Route path="/library" element={<Library />} />
            <Route path="/vip-agreement" element={<VipAgreement />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

function ToolQueryRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const search = location.search;
    if (!search) return;
    const params = new URLSearchParams(search);
    const tool = params.get("tool");
    if (tool && ["dstudio", "halftone", "ascii", "raster"].includes(tool)) {
      navigate(tool === 'raster' ? '/raster/' : `/${tool}` , { replace: true });
    }
  }, [location.search]);
  return null;
}

function AdminShortcut() {
  const navigate = useNavigate();
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.altKey && e.key === '9') {
        e.preventDefault();
        navigate('/admin');
      }
    };
    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [navigate]);
  return null;
}
